import { alertActions, userActions } from './';
import { authHeader, handleJSONResponse, store, history } from '../helpers';

// Inner Helpers
const checkJSONRequest = (response) => {
  const dispatch = store.dispatch;
  return handleJSONResponse(response, (data, code) => {
    if (code === 401) dispatch(userActions.logout());
    if (code !== 401) history.push('/error?code=403');
  });
};

export const SCHOOLS_FETCHONE_SUCCESS = 'SCHOOLS_FETCHONE_SUCCESS';
export const SCHOOLS_CREATEONE_SUCCESS = 'SCHOOLS_CREATEONE_SUCCESS';
export const SCHOOLS_UPDATEONE_SUCCESS = 'SCHOOLS_UPDATEONE_SUCCESS';
export const SCHOOLS_GETALL_REQUEST = 'SCHOOLS_GETALL_REQUEST';
export const SCHOOLS_GETALL_SUCCESS = 'SCHOOLS_GETALL_SUCCESS';
export const SCHOOLS_GETALL_FAILURE = 'SCHOOLS_GETALL_FAILURE';

export const schoolsActions = {
  getSchool: fetchOne,
  createItem,
  updateItem,
  getSchools: getAll,
  // delete: _delete
};

function fetchOne(id) {
  return (dispatch) => {
    fetch(`/api/schools/${id}`, {
      method: 'GET',
      headers: authHeader(),
    })
      .then(checkJSONRequest)
      .then((data) => dispatch(success(data[0] || null)));
  };
  // function request() { return { type: usersConstants.GETALL_REQUEST } }
  function success(item) {
    return { type: SCHOOLS_FETCHONE_SUCCESS, item };
  }
  // function failure(error) { return { type: usersConstants.GETALL_FAILURE, error } }
}

function createItem(item) {
  return (dispatch) => {
    fetch(`/api/schools`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(item),
    })
      .then(checkJSONRequest)
      .then((data) => dispatch(success(data || null)));
  };
  // function request() { return { type: usersConstants.GETALL_REQUEST } }
  function success(item) {
    return { type: SCHOOLS_CREATEONE_SUCCESS, item: item };
  }
  // function failure(error) { return { type: usersConstants.GETALL_FAILURE, error } }
}

function updateItem(item) {
  return (dispatch) => {
    fetch(`/api/schools/${item._id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(item),
    })
      .then(checkJSONRequest)
      .then((data) => {
        dispatch(success(data || null));
        dispatch(alertActions.success(`School successfully updated.`));
        setTimeout(() => dispatch(alertActions.clear()), 3000);
      });
  };
  // function request() { return { type: usersConstants.GETALL_REQUEST } }
  function success(item) {
    return { type: SCHOOLS_UPDATEONE_SUCCESS, item: item };
  }
  // function failure(error) { return { type: usersConstants.GETALL_FAILURE, error } }
}

function getAll() {
  return (dispatch) => {
    dispatch(request());

    fetch(process.env.REACT_APP_API_URL + '/schools/all', {
      method: 'GET',
      headers: authHeader(),
    })
      .then(checkJSONRequest)
      .then(
        (items) => dispatch(success(items)),
        (error) => dispatch(failure(error))
      );
  };

  function request() {
    return { type: SCHOOLS_GETALL_REQUEST };
  }
  function success(items) {
    return { type: SCHOOLS_GETALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: SCHOOLS_GETALL_FAILURE, error };
  }
}
